<template>
    <div class="animated revealUp">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 10px">
          <div class="d-block">
            <div class="section-title">Merchandise Vouchers</div>
            <div class="section-subTitle my-2">
              {{ $tc("manageAllVouchers") }}
            </div>
          </div>
          <div>
            <b-form-input v-debounce:300="onSearchVoucherList" v-model="searchValue"
              :placeholder="$tc('searchs')"></b-form-input>
          </div>
        </div>
  
        <div class="d-flex align-items-center" style="gap: 10px">
          <div>
            <b-button v-if="
              cinema_manager_add_edit_disabled != 3 &&
              $can('create', 'Vouchers')
            " variant="default" to="add-vouchers-merch" class="btn-blue">{{ $t("add") }}</b-button>
          </div>
  
          <div class="d-flex align-items-center">
            <div class="mx-2">
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  <strong>{{ viewingRange }}</strong>
                </template>
                <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
                  @click="onDropDownChangeValue(list.name)" href="#">{{ list.name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
  
      <div class="divscroll">
        <table class="list-view-table">
          <thead>
            <tr>
              <th class="text-left">
                <span class="">{{ $tc("status", 2) }}</span>
              </th>
  
              <th style="width: 250px">
                {{ $t("voucher") }}
              </th>
              <th>
                {{ $t("code") }}
              </th>
              <th>
            {{ "From" }}
              </th>
              <th>
               {{ "To" }}
              </th>
         
            </tr>
          </thead>
          <tbody v-if="vocuerList && vocuerList.length > 0">
            <tr v-for="(voucherItem, voucherIndex) in vocuerList" :key="voucherIndex" class="light_grey_back">
           
              <td>
                <div class="d-flex align-items-center justify-content-start">
                  <StatusDot :status="voucherItem.voucher_is_active == 'Y'
                      ? 'active'
                      : voucherItem.voucher_is_active == 'N' && 'inactive'
                    " />
                  <div class="ml-2" v-b-tooltip="'Edit Voucher'" tabindex="0">
                    <i v-if="
                      cinema_manager_add_edit_disabled != 3 &&
                      $can('update', 'Vouchers')
                    " class="edit-pen icon blue-icon cursor-pointer"
                      @click.prevent.stop="onEditVoucher(voucherItem)"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex">
                  <b-dropdown right variant="edit" class="mr-2" v-if="false">
                    <b-dropdown-item v-if="
                      cinema_manager_add_edit_disabled != 3 &&
                      $can('update', 'Vouchers')
                    " v-on:click="onEditVoucher(voucherItem)">
                      <span class="edit-pen"></span>
                      {{ $t("edit") }}
                    </b-dropdown-item>
                  </b-dropdown>
                  {{ voucherItem.voucher_name }}
                </div>
              </td>
              <td>{{ voucherItem.voucher_code }}</td>
            
              <td>
                {{
                  moment(voucherItem.voucher_from_date).format(
                    "DD MMM YYYY"
                  )
                }}
              </td>
              <td>
                {{
                  voucherItem.voucher_to_date
                    ? moment(voucherItem.voucher_to_date).format(
                      "DD MMM YYYY"
                    )
                    : "-"
                }}
              </td>
             
            </tr>
          </tbody>
  
          <tbody v-else>
            <tr>
              <td colspan="3">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination v-if="vocuerList.length > 0" v-model="currentPage" :total-rows="rows"
          @change="onChangePagination($event)" :per-page="perPage" aria-controls="my-table"></b-pagination>
      </div>
    </div>
   
  </template>
  
  <script>
  import MarketingService from "@/services/MarketingService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import moment from "moment";
  
  export default {
    components: {
      StatusDot,
      NoRecords,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        vocuerList: [],
        debounce: null,
        searchValue: "",  
      };
    },
    mounted() {
      this.getVoucherList();
    },
    beforeMount() {
      this.cinema_manager_add_edit_disabled =
        this.secureStore.get("USINFO").role_id;
      this.getviewingnumber();
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }
  
        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);
  
        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },
  
    methods: {
      moment,
      onSearchVoucherList() {
        this.currentPage = 1;
        this.getVoucherList();
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function (event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getVoucherList();
        } else {
          this.currentPage = event;
          this.getVoucherList();
        }
      },
      getVoucherList: function () {
        this.vocuerList = [];
        let loader = this.$loading.show();
  
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
        };
        MarketingService.GetVouchersMerchandise(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.vocuerList = data.Records;
               // console.log("this.vocuerList",this.vocuerList)
                this.rows = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
  
      /* eslint-disable */
      onEditVoucher: function ({ m_voucher_id }) {
        this.$router.push({
          path: `/vouchers/edit-vouchers-merch/${m_voucher_id}`,
        });
      },
    },
  };
  </script>
  <style>
  .divscroll {
    overflow-x: scroll;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Pages/MerchVouchers/getVoucherMerchandise.vue